"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _button = require("@jsluna/button");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _constants = require("../utils/constants");

var _grid = require("@jsluna/grid");

var _form = require("@jsluna/form");

var _icons = require("@jsluna/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var FileUpload = function FileUpload(_ref) {
  var id = _ref.id,
      acceptMultiple = _ref.acceptMultiple,
      error = _ref.error,
      disabled = _ref.disabled,
      value = _ref.value,
      setValue = _ref.setValue;

  var _useState = (0, _react.useState)(''),
      inputError = _useState[0],
      setInputError = _useState[1];

  var onAddImage = function onAddImage(e) {
    setInputError('');
    var data = [];
    var files = e.target.files;

    if (files.length + (value ? value.length : 0) > _constants.MAX_FILE_UPLOAD) {
      setInputError("You can only upload a maximum of " + _constants.MAX_FILE_UPLOAD + " files");
      return;
    }

    Array.from(files).forEach(function (x) {
      switch (x.type) {
        case 'image/png':
        case 'image/jpeg':
        case 'image/gif':
          data.push({
            file: x,
            previewUrl: URL.createObjectURL(x)
          });
          break;

        default:
          setInputError('Invalid file format was uploaded, please upload a .PNG, .JPEG or .GIF file');
          return;
      }
    });

    if (acceptMultiple) {
      setValue([].concat(value, data));
      return;
    }

    setValue(data);
  };

  var removeImage = function removeImage(id) {
    return setValue([].concat(value).filter(function (x) {
      return x.id !== id;
    }));
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, value && value.length > 0 ? value.map(function (x) {
    return /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: {
        default: '1/1',
        sm: '1/2',
        md: '1/3'
      },
      key: (0, _uuid.v1)()
    }, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "2/3",
      className: "ln-u-padding"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "image-holder"
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "img-holder",
      src: x.previewUrl,
      className: "image"
    }))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/3"
    }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
      variant: "text",
      label: "Close option menu",
      color: "dark",
      hideLabel: true,
      onClick: function onClick() {
        return removeImage(x.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.Cancel, null))));
  }) : /*#__PURE__*/_react.default.createElement("div", null)), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, /*#__PURE__*/_react.default.createElement(_form.FormGroup, {
    name: "file-upload-form-" + id,
    error: inputError
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    id: "file-upload-input-" + id,
    style: {
      display: 'none'
    },
    accept: "image/*",
    multiple: acceptMultiple,
    onChange: function onChange(e) {
      return onAddImage(e);
    }
  }), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      sm: '1/2',
      md: '1/3'
    },
    className: "ln-u-hard"
  }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    onClick: function onClick() {
      return document.getElementById("file-upload-input-" + id).click();
    },
    disabled: disabled || acceptMultiple && value && value.length === 5 || !acceptMultiple && value && value.length === 1,
    fullWidth: true
  }, acceptMultiple ? 'Upload images' : 'Upload an image')))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, error ? _constants.FILE_UPLOAD_TYPE_ERROR : '')));
};

FileUpload.propTypes = {
  /** The unique identifier of the question */
  id: _propTypes.default.string.isRequired,

  /** Indicates whether multiple files can be uploaded in the response */
  acceptMultiple: _propTypes.default.bool.isRequired,

  /** Indicates whether the component should be disabled */
  disabled: _propTypes.default.bool,

  /** The response value for this component */
  value: _propTypes.default.array,

  /** Function to set the response value for this component */
  setValue: _propTypes.default.func,

  /** Indicates whether there is an error with the given response */
  error: _propTypes.default.bool
};
FileUpload.defaultProps = {
  disabled: false,
  value: [],
  setValue: function setValue() {},
  error: false
};
var _default = FileUpload;
exports.default = _default;